import { render } from "./RequirementEditorModal.vue?vue&type=template&id=0fd5e7e1&scoped=true"
import script from "./RequirementEditorModal.vue?vue&type=script&lang=js"
export * from "./RequirementEditorModal.vue?vue&type=script&lang=js"

import "./RequirementEditorModal.vue?vue&type=style&index=0&id=0fd5e7e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd5e7e1"]])

export default __exports__